import { ToggleField } from './ToggleField'
import { withToggleField } from './withToggleField'

const ConnectedToggleField = withToggleField(ToggleField)

export { ConnectedToggleField as ToggleField }
